const es = {
  evirPx_settings: 'Configuración',
  evirPx_settings_description: 'Ver el',
  evirPx_missing_inspection_rules_report: 'informe de reglas de inspección faltantes',
  evirPx_settings_create_edit_rules: 'para crear y editar nuevas reglas para tus activos.',
  evirPx_settings_saved: 'Configuración guardada exitosamente',
  evirPx_settings_save_failed: 'Error al guardar: no se recibieron datos',
  evirPx_settings_save_error: 'No se pudo guardar la configuración. Inténtalo de nuevo.',
  evirPx_settings_user_not_available: 'La información del usuario no está disponible',
  evirPx_default_asset_type: 'Tipo de activo predeterminado para EVIR Mobile',
  evirPx_default_asset_type_desc: 'Elige qué tipo de activo debe ser el predeterminado para todas las inspecciones futuras.',
  evirPx_inspection_image_retention: 'Retención de inspección e imagen',
  evirPx_retention_desc: 'Período de tiempo que se conservarán las inspecciones e imágenes en el archivo.',
  evirPx_retain_for_number_of_years: 'Retener por número de años',
  evirPx_save: 'Guardar Configuración',
  evirPx_undo: 'Deshacer',
  evirPx_saving: 'Guardando...',
  evirPx_retention_1_year: '1 Año',
  evirPx_retention_2_years: '2 Años',
  evirPx_retention_3_years: '3 Años',
  evirPx_retention_5_years: '5 Años',
};

export default es;
